import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Loginsuc',
  templateUrl: './loginsuc.component.html'
})
export class LoginsucComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/login_sucess/loginsuc.component.ts